



































































































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend, clone,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import firebase from 'firebase'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import NewSlide from './NewSlide.vue'
import DisplayScheduler from './DisplayScheduler.vue'
import {
  addToBoard, removeFromBoard, updateSlide, deleteSlide, makeActive,
} from '../../helpers/display-functions'

// const { vueVimeoPlayer } = require('vue-vimeo-player')

// Filter Functions

const DisplayBoardCollection = collection<DisplayBoardType>('displayBoards')
const DisplaySlideCollection = collection<DisplaySlideType>('displaySlides')

@Component({
  components: {
    // vueVimeoPlayer,
    CDatePicker,
    NewSlide,
    DisplayScheduler,
  },
})

export default class SingleSlide<T extends Vue> extends Mixins(MainMixin) {
  @Prop() data!: DisplaySlideType

  @Prop({ default: [] }) boards!: DisplayBoardType[]

  @Prop({ default: null }) activeBoard!: DisplayBoardType | null

  slideLoaded = false

  isActive = this.data.active

  // @Watch('activeBoard', { deep: true, immediate: true })
  // slideUpdated(board:DisplaySlideType) {

  created () {
    this.resetSlideFunc()
  }

  displayScheduleKey = 0

  async resetSlide () {
    await this.resetSlideFunc()
    this.displayScheduleKey += 1
  }

  async resetSlideFunc () {
    const result = await db.collection('displaySlideDetails').where('slide', '==', this.data.id).get()
    console.log('result: ', result)
    const details: any = result.docs[0] ? result.docs[0].data() : null
    console.log('details are: ', details)
    // const details:SlideDetailsType|undefined|null = this.activeBoard ? this.activeBoard.slides.find(s => s.id === this.data.id) : null
    if (!details) return false
    this.slideDetails = clone(details)
    if (!this.slideDetails) return false
    this.slideDetails.id = result.docs[0].id
    this.calcSeconds = typeof details.duration === 'number' ? Number(parseInt(String(details.duration / 1000), 10)) : 10
    this.updateSeconds()
    const start = details.startDate
    const end = details.endDate
    this.detailsMap.scheduleStartDate = details.startDate !== null
    this.detailsMap.scheduleEndDate = details.endDate !== null
    this.slideLoaded = true
    return true
  }

  updateSeconds () {
    if (!this.slideDetails) return false
    this.slideDetails.duration = Number(this.calcSeconds * 1000)
    return true
  }

  // schedule = [{ start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }]

  @Emit()
  display (board: string, slide: string) {
    return [board, slide]
  }

  @Emit()
  makeactive (board: DisplayBoardType) {
    return board
  }

  get landscape () {
    return this.data.landscape
  }

  get dayStartTime () {
    if (!this.activeBoard) return 0
    return this.activeBoard.startHour
  }

  addNewSlide = false

  detailsMap = {
    scheduleStartDate: false,
    scheduleEndDate: false,
  }

  // resetSlide() {
  //   const details:SlideDetailsType|undefined|null = this.activeBoard ? this.activeBoard.slides.find(slide => slide.id === this.data.id) : null
  //   this.slideDetails = details || null
  //   this.calcSeconds = details ? parseInt(String(details.duration / 1000), 10) : 10
  //   this.detailsMap = {
  //     scheduleStartDate: false,
  //     scheduleEndDate: false,
  //   }
  // }

  get allBoards () {
    return this.boards.filter(board => board.landscape === this.landscape)
  }

  currentBoards: DisplayBoardType[] = this.allBoards.filter(board => board.id && this.data.boards.indexOf(board.id) !== -1)

  potentialBoards: DisplayBoardType[] = this.allBoards.filter(board => board.id && this.data.boards.indexOf(board.id) === -1)

  imageErrorCount = 0

  imageKey = 0

  refreshImage () {
    console.log('error loading image')
    if (this.imageErrorCount > 4) return false
    setTimeout(() => {
      this.imageKey += 1
      this.imageErrorCount += 1
    }, 1500)
    return true
  }

  boardMoveLoading = false

  slideDetails: SlideDetailsType | null = {
    startDate: null,
    endDate: null,
    schedule: [{ start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }, { start: 0, end: 24 }],
    duration: 10000,
    board: '',
    slide: this.data.id || '',
  }

  calcSeconds: number = 10

  async addToBoard (slide: string, board: string, test: boolean, i: number) {
    this.boardMoveLoading = true
    const boardData = this.allBoards.find(b => b.id === board)
    console.log('boardData is: ', boardData)
    const result = await addToBoard(slide, board, test, boardData ? boardData.startHour : 0)
    const b = this.potentialBoards.splice(i, 1)
    this.currentBoards.push(b[0])
    this.boardMoveLoading = false
  }

  async removeFromBoard (slide: string, board: string, i: number) {
    this.boardMoveLoading = true
    const result = await removeFromBoard(slide, board)
    const b = this.currentBoards.splice(i, 1)
    this.potentialBoards.push(b[0])
    this.boardMoveLoading = false
  }

  loading = false

  bottomLoading = false

  async makeSlideActive (active: boolean) {
    if (!this.data || !this.data.id) return false
    this.bottomLoading = true
    try {
      makeActive(this.data.id, active)
      this.bottomLoading = false
      this.isActive = active
      return this.$toast.success(`Slide is now ${active ? 'Active' : 'Inactive'}`)
    } catch (e) {
      console.log(e)
      this.bottomLoading = false
      return this.$toast.error('Error Updating Slide')
    }
  }

  async deleteSlide () {
    if (!this.data || !this.data.id) return false
    this.bottomLoading = true
    try {
      const boards = this.currentBoards.map(board => board.id || '')
      await deleteSlide(this.data.id, boards)
      this.bottomLoading = false
      this.$toast.success('Slide Successfully Deleted')
      return this.display(this.$store.state.appStore.activeTab, 'all')
    } catch (e) {
      console.log('error: ', e)
      this.bottomLoading = false
      return this.$toast.error('Error Deleting Slide')
    }
  }

  async updateSlide () {
    this.loading = true
    try {
      if (!this.slideDetails || !this.slideDetails.id) {
        console.log('no id or details')
        this.loading = false
        return false
      }
      await updateSlide(this.slideDetails.id, this.slideDetails)
      this.loading = false
      return this.$toast.success('Slide Successfully Updated')
    } catch (e) {
      this.loading = false
      console.log(e)
      return this.$toast.error('Error Updating Slide')
    }
  }

  showFullImage = false
}
